import { useTypedSelector } from "store"
import { selectedColorSelector } from "../color/colorSelectors"
import { selectedDetailingSelector } from "../detailing/detailingSelectors"
import { selectedUpholsterySelector } from "../upholstery/upholsterySelectors"

const useInStock = () => {
  const selectedColor = useTypedSelector(selectedColorSelector)
  const selectedUpholstery = useTypedSelector(selectedUpholsterySelector)
  const selectedDetailing = useTypedSelector(selectedDetailingSelector)

  const inStock =
    (!selectedColor?.details || selectedColor?.details?.inStock) &&
    (!selectedUpholstery?.details || selectedUpholstery?.details?.inStock) &&
    (!selectedDetailing?.details || selectedDetailing?.details?.inStock)

  return inStock
}

export default useInStock
